import { EndorsementStatus } from "@covertree/agent-portal-graphql";
import { Status } from "@covertree/ui/content/StatusLabel";

export const DISPLAY_LABELS: Record<EndorsementStatus, string> = {
  [EndorsementStatus.InProgress]: "IN PROGRESS",
  [EndorsementStatus.AwaitingApproval]: "AWAITING APPROVAL",
  [EndorsementStatus.ReadyToIssue]: "READY TO ISSUE",
  [EndorsementStatus.PaymentFailed]: "PAYMENT FAILED",
  [EndorsementStatus.IssuanceFailed]: "ISSUANCE FAILED",
  [EndorsementStatus.ErrorOccurred]: "ERROR OCCURRED",
  [EndorsementStatus.Issued]: "ISSUED",
  [EndorsementStatus.Discarded]: "DISCARDED",
};

export function mapEndorsementStatusType(status: EndorsementStatus): Status {
  switch (status) {
    case EndorsementStatus.Issued:
    case EndorsementStatus.ReadyToIssue:
    case EndorsementStatus.AwaitingApproval:
      return "active";
    case EndorsementStatus.PaymentFailed:
    case EndorsementStatus.IssuanceFailed:
    case EndorsementStatus.ErrorOccurred:
      return "expired";
    case EndorsementStatus.InProgress:
    default:
      return "initial";
  }
}

export interface EndorsementCardProps {
  endorsementId: string;
  effectiveDate: string;
  status: EndorsementStatus;
  reason?: string;
  isSocotraNative?: boolean;
  isExpiredPolicy?: boolean;
  isReadOnly?: boolean;
  onUpdateEndorsement?: () => void;
  onIssueEndorsement?: () => void;
  onReviewIssue?: () => void;
  onUwReview?: () => void;
  onDiscard?: () => void;
}
